import { AbstractControl } from '@angular/forms'
import { ClientRepresentedEvent } from '@app/modules/events/models/event.model'
import { AbstractValidator } from './abstract.validator'
import { ValidationTypes } from './validation.types'

export class ScheduleValidator implements AbstractValidator {
  private static scheduleTypes = {
    minute: { maxValue: 59, text: 'minutes before' },
    hour: { maxValue: 23, text: 'hours before' },
    day: { maxValue: 0, text: 'days before' }
  }
  static type = ValidationTypes.validateWith

  static validateWith(reminderSchedules: AbstractControl[], event: ClientRepresentedEvent) {
    return (control: AbstractControl) => {
      if (control.pristine || !control.value) {
        return null
      }
      return this.isNotUnique(control, reminderSchedules) || this.isInRange(control) || this.timeNotPassed(control, event)
    }
  }
  static timeNotPassed(schedule, event) {
    let reminderTimestamp = 0
    switch (schedule.value.type) {
      case 'minute':
        reminderTimestamp = 60000 * schedule.value.value
        break
      case 'hour':
        reminderTimestamp = 3600000 * schedule.value.value
        break
      case 'day':
        reminderTimestamp = 86400000 * schedule.value.value
        break
      default:
        break
    }
    const timestampBeforeEvent = new Date(event.public_start_date.getTime() - reminderTimestamp).getTime()
    return new Date().getTime() - timestampBeforeEvent > 1 ? { notificationPassed: true } : null
  }
  static isInRange(schedule) {
    const max = this.scheduleTypes[schedule.value.type]?.maxValue || 0
    if (schedule.value.value > max && max !== 0) return { max: true }
    if (schedule.value.value < 1 && !!schedule.value.type) return { min: true }
    return null
  }
  static isNotUnique(schedule, reminderSchedules) {
    let isSelectedControlDuplicated = false
    reminderSchedules.forEach((control, key) => {
      const isDuplicateFlag = reminderSchedules.some((control2, key2) => {
        if (key != key2 && control.value.value === control2.value.value && control.value.type === control2.value.type) {
          reminderSchedules[key].setErrors({ notUnique: true })
          if (schedule === reminderSchedules[key]) isSelectedControlDuplicated = true
          return true
        }
      })
      if (!isDuplicateFlag && reminderSchedules[key]?.errors?.notUnique) reminderSchedules[key].setErrors(null)
    })
    return isSelectedControlDuplicated ? { notUnique: true } : null
  }
}
